import { Image, useColorModeValue as mode } from "@chakra-ui/react"
import RevisionHistoryBg from '../../Images/Revision-History.jpg'

export const RightRevisionHistory = () => {
    return <Image src={RevisionHistoryBg} opacity={mode(1, .7)} />
}